export default [
  { name: "خانه", link: "/" },
  {
    name: "راهنما",
    link: "/howitworks",
    websiteAddress: true,
  },
  { name: "پیشنهاد مسیر", link: "/survey" },
  {
    name: "سوالات متداول",
    link: "/faq",
    websiteAddress: true,
  },
  {
    name: "پشتیبانی",
    link: "/support",
    websiteAddress: true,
  },
];
